export const AodaActions = {
  SubmitAodaForm: 'AodaActions.SubmitAodaForm'
};

export const AodaMutations = {
  AodaForm: 'AodaMutations.AodaForm'
};
